import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Check } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data);
        if (data.payment_status !== "paid" && tries < 20) {
          timer = setTimeout(() => setTries((t) => t + 1), 2000);
        }
      } catch { /* ignore */ }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, tries]);

  const done = status.payment_status === "paid";

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-success">
      <div className={`mx-auto w-20 h-20 rounded-full grid place-items-center ${done ? "bg-forest text-white" : "bg-ochre text-charcoal"}`}>
        {done ? <Check size={36}/> : <div className="animate-spin w-8 h-8 border-4 border-charcoal border-t-transparent rounded-full"/>}
      </div>
      <h1 className="mt-6 font-serif text-4xl md:text-5xl font-bold">{done ? "Payment received!" : "Confirming payment…"}</h1>
      <p className="mt-4 text-charcoal/70">{done ? "Check your inbox — your confirmation email is on its way." : "This usually takes just a moment."}</p>
      {done && status.summary?.rows && (
        <div className="mt-8 mx-auto max-w-md bg-white rounded-3xl shadow-card p-6 text-left text-sm" data-testid="receipt">
          <div className="font-serif text-xl mb-3">Your booking</div>
          {status.summary.rows.map((r) => <div key={r.label} className={`flex justify-between gap-4 py-1 ${r.label === "Total paid" ? "border-t border-cream-alt mt-2 pt-2 font-bold text-terracotta" : ""}`} data-testid={`receipt-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}><span className="text-charcoal-muted">{r.label}</span><span className="text-right">{r.value}</span></div>)}
        </div>
      )}
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/" className="rounded-full bg-terracotta text-white px-6 py-3 font-semibold">Back to Home</Link>
        <Link to="/workshops" className="rounded-full bg-white border-2 border-terracotta text-terracotta px-6 py-3 font-semibold">Book Another</Link>
      </div>
    </div>
  );
}
